/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import BaseWrapper from '../../components/base-wrapper';

export default function save( props ) {
	const { attributes } = props;
	const { layout, columnSize, className, hideRating } = attributes;

	const wrapperClasses = classnames(
		className,
		`gutenify-testimonials-block-wrapper gutenify-testimonials-${ layout }`,
		`gutenify-testimonials-col-${ columnSize }`,
		hideRating && 'gutenify-testimonials-hide-rating',
	);
	return (
		<div className={ wrapperClasses }>
			<BaseWrapper { ...props } name="gutenify/testimonial">
				<div className="gutenify-testimonials-block">
					<InnerBlocks.Content />
				</div>
			</BaseWrapper>
		</div>

	);
}

